import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WorkerHeader from '../../worker-header/components/index';
import WorkerFooter from "../../worker-footer/components/index";
import { fetchWorkerJobs } from '../slice/workerJobsSlice';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { getJobCategories } from '../../worker-panel/slice/workerJobSlice';

const WorkerServices = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, jobs } = useSelector((state) => state.workerJobs);
  const [searchFor, setSearchFor] = useState(""); // teacher | support
  const [category, setCategory] = useState("");
  const [state, setState] = useState("");
  const [canShowJobs, setCanShowJobs] = useState(false);
  const [jobType, setJobType] = useState("");
  const [salaryMin, setSalaryMin] = useState("");
  const [salaryMax, setSalaryMax] = useState("");
  const [city, setCity] = useState("");
  const isFromExternal = Boolean(location.state?.fromExternal);

  const { userData } = useSelector(
    (state) => state.workerInfo
  );
  // console.log("userData", userData);
  const { jobCategories } = useSelector((state) => state.workerJob);

  const { role_id, states: defaultState } = userData;

// useEffect(() => {
//   if (!isFromExternal) return;

//   if (role_id) {
//     setSearchFor(Number(role_id));
//   }
// }, [isFromExternal, role_id]);



  useEffect(() => {
    if (searchFor || isFromExternal) {
      dispatch(getJobCategories(searchFor));
      // setCategory("");
    }
  }, [searchFor, dispatch]);

  const roles = {
    teacher: { id: 5, label: "Teachers & Assistants" },
    support: { id: 6, label: "Support Staffing Roles" },
  };

useEffect(() => {
  if (!location.state?.fromExternal) return;

  const {
    selectedCategory,
    selectedState,
    selectedCity,
    selectedJobType,
    selectedSalaryMin,
    selectedSalaryMax,
  } = location.state;

  if (selectedCategory) setCategory(String(selectedCategory));
  if (selectedState) setState(selectedState);
  if (selectedCity) setCity(selectedCity);
  if (selectedJobType) setJobType(selectedJobType);
  if (selectedSalaryMin) setSalaryMin(selectedSalaryMin);
  if (selectedSalaryMax) setSalaryMax(selectedSalaryMax);

  // setCanShowJobs(true);
}, [location.state]);



const filtersReady = isFromExternal
  ? Boolean(category || state || city || jobType || salaryMin || salaryMax)
  : Boolean(state);

useEffect(() => {
  if (!filtersReady) return;

  // 🚫 role is required ONLY for normal flow
  if (!isFromExternal && !searchFor) return;

  setCanShowJobs(true);

  dispatch(
    fetchWorkerJobs({
      role_type: isFromExternal ? undefined : searchFor,
      category: category || undefined,
      state: state || undefined,
      city: city || undefined,
      job_type: jobType || undefined,
      salary_min: salaryMin || undefined,
      salary_max: salaryMax || undefined,
    })
  );
}, [
  filtersReady,
  isFromExternal,
  searchFor,
  category,
  state,
  city,
  jobType,
  salaryMin,
  salaryMax,
]);




  const handleViewDetails = (jobId) => {
    // const token = localStorage.getItem("token");

    // if (!token) {
    //   toast.error("Login required");
    //   navigate("/signin");
    //   return;
    // }

    navigate(`/job-details/${jobId}`);
  };

  console.log("FETCHING WITH:", {
  role: searchFor,
  category,
  state,
  isFromExternal,
});


  // const getStatusClass = (status) => {
  //   switch (status?.toLowerCase()) {
  //     case "published":
  //       return "bg-success";
  //     case "draft":
  //       return "bg-warning text-dark";
  //     case "expired":
  //       return "bg-danger";
  //     default:
  //       return "bg-secondary";
  //   }
  // };

  return (
    <>
      <WorkerHeader />
      <main className="overflow-hidden">

        <section className="homepad pb-5">
          <div className="container">
            <h4 className="text-left mb-4 pb-2 font-weight-bold text-primary display-6 montserrat">
              Find Your Perfect Job
            </h4>

            <div className="row">
              {/* Form section - matches jobs section width */}
              <div className="col-12 col-lg-9 mx-auto">
                <div className="form-section bg-light rounded p-3 p-sm-4">

                  <div className="row g-3">

                    {/* STEP 1: SEARCHING FOR */}
                    <div className="col-12 text-left mb-4 d-flex flex-wrap align-items-center gap-3">
                      <label className="fw-bold mb-2 d-block" style={{ fontSize: "24px" }}>
                        Looking for a job as
                      </label>

                      <div className="form-check form-check-inline" style={{ fontSize: "20px" }}>
                        <input
                          type="radio"
                          className="form-check-input"
                          id="teacher"
                          name="searchFor"
                          value={roles.teacher.id}
                          checked={searchFor === roles.teacher.id}
                          onChange={() => {
                            setSearchFor(roles.teacher.id);
                            // setCategory("");
                            // setState("");
                            // setJobType("");
                            // setSalaryMin("");
                            // setSalaryMax("");
                            // setCity("");
                          }}
                        />
                        <label className="form-check-label fw-semibold" htmlFor="teacher">
                          Teachers & Assistants
                        </label>
                      </div>

                      <div className="form-check form-check-inline" style={{ fontSize: "20px" }}>
                        <input
                          type="radio"
                          className="form-check-input"
                          id="support"
                          name="searchFor"
                          value={roles.support.id}
                          checked={searchFor === roles.support.id}
                          onChange={() => {
                            setSearchFor(roles.support.id);
                            // setCategory("");
                            // setState("");
                            // setJobType("");
                            // setSalaryMin("");
                            // setSalaryMax("");
                            // setCity("");
                          }}
                        />
                        <label className="form-check-label fw-semibold" htmlFor="support">
                          Support Staffing Roles
                        </label>
                      </div>
                    </div>

                    {/* STEP 2: CATEGORY */}
                    {(searchFor || isFromExternal) && (
                      <div className="col-12 col-md-5 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3 mb-3">
                        <label className="form-label text-primary mb-1 font-weight-semibold">
                          Category
                        </label>
                        <select
                          className="form-select rounded-pill shadow-sm flex-grow-1"
                          value={category}
                          onChange={(e) => {
                            setCategory(e.target.value);
                            // setState("");
                            // setJobType("");
                            // setSalaryMin("");
                            // setSalaryMax("");
                            // setCity("");
                          }}
                        >
                          <option value="">-- Select Category --</option>
                          {jobCategories?.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}


                    {/* STEP 3: STATE */}
                    {(category || state) && (
                      <div className="col-12 col-md-3 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3 mb-3">
                        <label className="form-label text-primary mb-1 font-weight-semibold">
                          State
                        </label>
                        <select
                          className="form-select rounded-pill shadow-sm flex-grow-1"
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                        >
                          <option value="">-- Select State --</option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                      </div>
                    )}

                    {/* CITY */}
                    {canShowJobs && (
                      <div className="col-12 col-md-4 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3 mb-3">
                        <label className="form-label text-primary mb-1 font-weight-semibold" >
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill shadow-sm flex-grow-1"
                          placeholder="City"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    )}

                    {/* JOB TYPE + SALARY RANGE */}
                    {canShowJobs && (
                      <div className="col-12 d-flex flex-column flex-md-row flex-wrap gap-3 mt-3">
                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3 flex-grow-1">
                          <label className="form-label text-primary mb-1 font-weight-semibold" style={{ minWidth: "65px" }}>
                            Job Type
                          </label>
                          <select
                            className="form-select rounded-pill shadow-sm flex-grow-1"
                            value={jobType}
                            onChange={(e) => setJobType(e.target.value)}
                          >
                            <option value="">All Job Types</option>
                            <option value="full-time">Full-Time</option>
                            <option value="part-time">Part-Time</option>
                            <option value="internship">Internship</option>
                          </select>
                        </div>

                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3 flex-grow-2">
                          <label className="form-label text-primary mb-1 font-weight-semibold" style={{ minWidth: "90px" }}>
                            Salary Range
                          </label>
                          <input
                            type="number"
                            className="form-control rounded-pill shadow-sm me-2 flex-grow-1"
                            placeholder="From"
                            value={salaryMin}
                            onChange={(e) => setSalaryMin(e.target.value)}
                            min="0"
                          />
                          <input
                            type="number"
                            className="form-control rounded-pill shadow-sm flex-grow-1"
                            placeholder="To"
                            value={salaryMax}
                            onChange={(e) => setSalaryMax(e.target.value)}
                            min="0"
                          />
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>

              {/* Support card - right side */}
              <div className="col-12 col-lg-3">
                <div className="support-card text-white bg-primary rounded15 p-4">
                  <div className="p-md-2">
                    <h5 className="font-weight-semibold font-size-18 mb-3">Need Help?</h5>
                    <p className="mb-3">Reach out to our support executive<br />for any help</p>
                    <div className="phone-number my-4">
                      <img src="/assets/images/phone-call-01.svg" className="img-fluid" alt="" />
                      <span>+91-6353385120</span>
                    </div>
                    <a href="https://wa.me/916353385120" target="_blank" className="whatsapp-button">
                      <img src="/assets/images/chat-whatsapp-icon.svg" className="img-fluid" alt="" />
                      Chat on Whatsapp
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>


        {/* LOADING */}
        {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {error && <p className="text-danger">{error}</p>}

        {canShowJobs && (
          <section className="homepad pt-0" style={{ minHeight: "60vh" }}>
            <div className="container">
              <div className="row d-flex align-items-stretch">
                <div className="col-lg-9 services-listpage" style={{ minHeight: "1312px" }}>
                  <div className="form-section bg-light rounded p-3 p-sm-4">
                    {jobs?.length === 0 ? (
                      <div className="text-center py-5">
                        <h5 className="text-muted">No jobs available</h5>
                      </div>
                    ) : (
                      jobs?.map((job) => {
                        return (
                          <div
                            className="row"
                            style={{ cursor: "pointer" }}
                            key={job.id}
                            onClick={() => handleViewDetails(job.id)}
                          >
                            <div className="col-12">
                              <div className="card activity-card d-md-flex flex-md-row p-4 position-relative">

                                {/* 🔹 JOB TYPE (Top Right) */}
                                <div
                                  className="d-flex align-items-center gap-2 position-absolute"
                                  style={{ top: "15px", right: "15px", zIndex: 2 }}
                                >
                                  {/* JOB TYPE */}
                                  <span className="badge bg-info text-white">
                                    {job.job_type}
                                  </span>
                                </div>

                                <div
                                  className="position-relative services-list-box"
                                  style={{
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    width: "25%",
                                  }}
                                >
                                  <a href="#" className="text-decoration-none position-absolute top-0 end-0 m-2">
                                    <i className="fa fa-heart-o text-white font-size-22" />
                                  </a>
                                </div>

                                <div className="card-body py-0 pe-0 ps-0 ps-md-4 ms-xl-1 mt-4 mt-md-0">

                                  <h6 className="font-weight-bold text-primary font-size-22 mb-2 montserrat">
                                    {job.title}
                                  </h6>

                                  <div className="badge bg-success px-3 py-2 font-size-14 mb-3">
                                    {/* <strong>Categories:</strong>{" "} */}
                                    {job.jobs_categories?.[0]?.name || "N/A"}
                                  </div>



                                  <div className="text-muted font-size-14 mb-2">
                                    <strong>Min Salary:</strong> {job.salary_min}{" "}
                                    <strong>Max Salary:</strong> {job.salary_max}
                                  </div>



                                  <div className="text-muted font-size-14 mb-2">
                                    <strong>Role:</strong>{" "}
                                    {Object.values(roles).find(r => r.id === job.role_id)?.label || "Unknown Role"}
                                  </div>

                                  <div className="text-muted font-size-14 mb-2">
                                    <strong>Location:</strong> {job.state}, {job.city}
                                  </div>

                                  <p dangerouslySetInnerHTML={{ __html: job.description }} />

                                  <div className="d-flex justify-content-between align-items-center mt-4">
                                    <span
                                      className="rating-badge bg-primary font-size-16 rounded-pill text-white px-3 py-2"
                                      onClick={() => handleViewDetails(job.id)}
                                    >
                                      View Details
                                    </span>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                        );
                      })
                    )}
                  </div>
                </div>

                <div className="col-lg-3 mt-4 mt-lg-0 pt-2 pt-lg-0">

                  <div className="support-card text-white bg-primary rounded15 p-4 mt-4">
                    <div className="p-md-2">
                      <h5 className="font-weight-semibold font-size-18 mb-3">Need Help?</h5>
                      <p className="mb-3">Reach out to our support executive<br />for any help</p>
                      <div className="phone-number my-4">
                        <img src="/assets/images/phone-call-01.svg" className="img-fluid" alt="" />
                        <span>+91-6353385120</span>
                      </div>
                      <a href="https://wa.me/916353385120" target="_blank" className="whatsapp-button">
                        <img src="/assets/images/chat-whatsapp-icon.svg" className="img-fluid" alt="" />
                        Chat on Whatsapp
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        <div className="mobile-mt-services">
          <WorkerFooter />
        </div>

      </main>
    </>
  );
};

export default WorkerServices;